import { registerDataTableComponent } from '@vendure/admin-ui/core';

import { StockLevelStatusComponent } from './stock-level-status.component';

export default [
  registerDataTableComponent({
    component: StockLevelStatusComponent,
    tableId: 'product-variant-list',
    columnId: 'stock-on-hand',
  }),
];
